import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faSpinner } from "@fortawesome/free-solid-svg-icons";
import ActiveRidePage from "./ActiveRidePage";
import { decryptData } from "../utils/storageCrypto";

const RideDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const shipmentId = queryParams.get("shipmentId");
  const mobile = queryParams.get("mobile");
  const isBrickbucket = location.state?.isBrickbucket ?? true;

  const URL = process.env.REACT_APP_FORE_BRICKBUCKET;
  const [rideData, setRideData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchRideDetails = async () => {
    if (!mobile || !shipmentId) {
      setLoading(false);
      return;
    }

    setLoading(true);
    const encryptedToken = sessionStorage.getItem("token");
    const token = encryptedToken ? decryptData(encryptedToken) : null;

    try {
      const endpoint = `${URL}delivery-partner/get-ride-details?id=${encodeURIComponent(shipmentId)}&mobile=${encodeURIComponent(mobile)}`;

      const response = await fetch(endpoint, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
      });

      const result = await response.json();

      if (response.ok && result.data) {
        // Normalize in case the backend returns an array or an object
        const ride = Array.isArray(result.data) ? result.data[0] : result.data;
        setRideData(ride || null);
        console.log(ride)
      } else {
        setRideData(null);
      }
    } catch (err) {
      console.error("Error loading ride details:", err);
      setRideData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (mobile && shipmentId) {
      fetchRideDetails();
    } else {
      setLoading(false);
    }
  }, [mobile, shipmentId]);

  const handleBackToRides = () => {
    navigate(`/delivery/rides?mobile=${encodeURIComponent(mobile || "")}`, {
      state: { isBrickbucket },
    });
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center p-4">
        <FontAwesomeIcon
          icon={faSpinner}
          className="text-3xl text-blue-600 animate-spin mb-3"
        />
        <p className="text-sm font-semibold text-gray-600">
          Loading shipment details...
        </p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 pb-10">
      {/* Top Navigation Bar */}
      <div className="sticky top-0 z-10 bg-white border-b border-gray-200 px-4 py-3 shadow-sm flex items-center justify-between">
        <button
          onClick={handleBackToRides}
          className="flex items-center gap-2 text-sm font-bold text-gray-700 hover:text-gray-900"
        >
          <FontAwesomeIcon icon={faArrowLeft} />
          <span>Back to All Rides</span>
        </button>
      </div>

      <div className="px-4 py-4 max-w-md mx-auto">
        {rideData ? (
          <ActiveRidePage
            activeRide={rideData}
            GetRideDetails={fetchRideDetails}
            mobile={mobile}
            onGetNewRides={handleBackToRides}
          />
        ) : (
          <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-6 text-center">
            <p className="text-base font-semibold text-gray-700">
              Shipment details not found
            </p>
            <button
              onClick={handleBackToRides}
              className="mt-4 bg-blue-600 text-white font-bold px-4 py-2 rounded-xl text-sm"
            >
              Go to Rides List
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default RideDetails;